import { z } from 'zod';

import { baseJobSchema } from '~/shared/data-contract/job';
import { baseSkillSchema } from '~/shared/data-contract/skill';

const skillGapRelativeSchema = z.number().min(0).max(1);

export const skillGapTimelineDataSetItemSchema = z.object({
    date: z.string(),
    skillDemandAbsolute: z.number(),
    skillGapAbsolute: z.number(),
    skillGapRelative: skillGapRelativeSchema,
});

export const skillGapTimelineDataSetSchema = skillGapTimelineDataSetItemSchema.array();

export type SkillGapTimelineDataSetItem = z.infer<typeof skillGapTimelineDataSetItemSchema>;

export const overallSkillGapTimelineDataSetItemSchema = z.object({
    date: z.string(),
    skillGapRelative: skillGapRelativeSchema,
});

export const overallSkillGapTimelineDataSetSchema = overallSkillGapTimelineDataSetItemSchema.array();

export type OverallSkillGapTimelineDataSetItem = z.infer<typeof overallSkillGapTimelineDataSetItemSchema>;

export const businessIntelligenceOptionsSchema = z.object({
    canReadSkillGapTimeline: z.boolean(),
    canReadStatusOverview: z.boolean(),
    canReadTrendingJobs: z.boolean(),
    canReadTrendingSkills: z.boolean(),
    canReadUserVisibilities: z.boolean(),
});

export type BusinessIntelligenceOptions = z.infer<typeof businessIntelligenceOptionsSchema>;

export const businessIntelligenceTrendingSkillSchema = baseSkillSchema.extend({
    impressions: z.number(),
});

export type BusinessIntelligenceTrendingSkill = z.infer<typeof businessIntelligenceTrendingSkillSchema>;

export const businessIntelligenceTrendingSkillsResponseSchema = z.object({
    data: businessIntelligenceTrendingSkillSchema.array(),
});

export const businessIntelligenceTrendingJobSchema = baseJobSchema.extend({
    clicks: z.number(),
});

export type BusinessIntelligenceTrendingJob = z.infer<typeof businessIntelligenceTrendingJobSchema>;

export const businessIntelligenceTrendingJobsResponseSchema = z.object({
    data: businessIntelligenceTrendingJobSchema.array(),
});

export const businessIntelligenceVisibilitiesSchema = z.object({
    invisible: z.number(),
    visible: z.number(),
});

export type BusinessIntelligenceVisibilities = z.infer<typeof businessIntelligenceVisibilitiesSchema>;

const businessIntelligenceStatusCountSchema = z.object({
    count: z.number(),
});

export const businessIntelligenceStatusResponseSchema = z.object({
    jobs: businessIntelligenceStatusCountSchema,
    learningOpportunities: businessIntelligenceStatusCountSchema,
    skills: businessIntelligenceStatusCountSchema,
    users: businessIntelligenceStatusCountSchema,
});

export type BusinessIntelligenceStatusResponse = z.infer<typeof businessIntelligenceStatusResponseSchema>;
